import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-help-page',
    templateUrl: './help-page.component.html',
    styleUrls: ['./help-page.component.scss'],
})
export class HelpPageComponent {
    dictionary = environment.dictionary;

    constructor() {}
}
